/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * Configuration Service API
 * Documentation of the controllers and endpoints used in the configuration-service.
 * OpenAPI spec version: deploy-only-BS-816-2480
 */
import type { MainWebShop, StoreInfoDTO } from '@as-react/common-types/configuration-service';
import { faker } from '@faker-js/faker';
import { HttpResponse, delay, http } from 'msw';
import type { RequestHandlerOptions } from 'msw';

export const getGetStoreInfoByStoreIdResponseMock = (overrideResponse: Partial<StoreInfoDTO> = {}): StoreInfoDTO => ({
  storeId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  storeName: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  ...overrideResponse,
});

export const getGetStoreInfoByStoreIdServerResponseMock = (
  overrideResponse: Partial<StoreInfoDTO> = {}
): StoreInfoDTO => ({
  storeId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  storeName: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  ...overrideResponse,
});

export const getGetMainWebShopConfigServerResponseMock = (
  overrideResponse: Partial<MainWebShop> = {}
): MainWebShop => ({
  mainWebshopId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  businessUnitId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  businessUnit: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  market: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  marketId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  name: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  displayName: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  fasciaId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  fascia: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  orderReference: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  code: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  ttlBasketReservation: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  phoneNumber: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  invoicingStartDate: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]),
  alwaysShowProducts: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  showMultiFasciaOnPdp: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  exactStockThreshold: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  urls: faker.helpers.arrayElement([
    {
      [faker.string.alphanumeric(5)]: faker.string.alpha({ length: { min: 10, max: 20 } }),
    },
    undefined,
  ]),
  baseUrlImages: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  reviewProviderOverride: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  ...overrideResponse,
});

export const getGetStoreInfoByStoreIdMockHandler = (
  overrideResponse?:
    | StoreInfoDTO
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<StoreInfoDTO> | StoreInfoDTO),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/api/store/info/:mainWebshop/:storeId',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetStoreInfoByStoreIdResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetStoreInfoByStoreIdServerMockHandler = (
  overrideResponse?:
    | StoreInfoDTO
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<StoreInfoDTO> | StoreInfoDTO),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/public/store/info/:mainWebshop/:storeId',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetStoreInfoByStoreIdServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetMainWebShopConfigServerMockHandler = (
  overrideResponse?:
    | MainWebShop
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<MainWebShop> | MainWebShop),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/mainwebshop/name/:name',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetMainWebShopConfigServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};
export const getConfigurationServiceAPIMock = () => [
  getGetStoreInfoByStoreIdMockHandler(),
  getGetStoreInfoByStoreIdServerMockHandler(),
  getGetMainWebShopConfigServerMockHandler(),
];
